var map = {
	"./common/cash.png": 932,
	"./common/face.png": 8242,
	"./common/gold.png": 5155,
	"./common/pinduoduo_1.png": 4020,
	"./common/pinduoduo_10.png": 8718,
	"./common/pinduoduo_11.png": 7031,
	"./common/pinduoduo_12.png": 6972,
	"./common/pinduoduo_13.png": 6069,
	"./common/pinduoduo_14.png": 5914,
	"./common/pinduoduo_15.png": 7139,
	"./common/pinduoduo_16.png": 1864,
	"./common/pinduoduo_17.png": 9729,
	"./common/pinduoduo_18.png": 7798,
	"./common/pinduoduo_19.png": 4127,
	"./common/pinduoduo_2.png": 5647,
	"./common/pinduoduo_20.png": 7183,
	"./common/pinduoduo_21.png": 8438,
	"./common/pinduoduo_22.png": 5853,
	"./common/pinduoduo_23.png": 4724,
	"./common/pinduoduo_24.png": 6715,
	"./common/pinduoduo_25.png": 3058,
	"./common/pinduoduo_26.png": 7065,
	"./common/pinduoduo_27.png": 1312,
	"./common/pinduoduo_28.png": 5143,
	"./common/pinduoduo_29.png": 5150,
	"./common/pinduoduo_3.png": 1846,
	"./common/pinduoduo_30.png": 4180,
	"./common/pinduoduo_31.png": 8077,
	"./common/pinduoduo_32.png": 4102,
	"./common/pinduoduo_33.png": 7391,
	"./common/pinduoduo_34.png": 6064,
	"./common/pinduoduo_4.png": 1817,
	"./common/pinduoduo_5.png": 7616,
	"./common/pinduoduo_6.png": 8827,
	"./common/pinduoduo_7.png": 3634,
	"./common/pinduoduo_9.png": 1164,
	"./common/sacar.png": 9635,
	"./en/pinduoduo_8.png": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;